"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_CONFIGURATION = exports.DEFAULT_PLATFORM_CONFIGURATION = void 0;
exports.getConfigurationByPlatform = getConfigurationByPlatform;
exports.isPlatform3pAggregator = isPlatform3pAggregator;
exports.isPaymentRequired = isPaymentRequired;
exports.isDeliverySupported = isDeliverySupported;
exports.isEmailConfirmationRequired = isEmailConfirmationRequired;
const types_1 = require("../types");
exports.DEFAULT_PLATFORM_CONFIGURATION = {
    is3pAggregator: false,
    isDeliverySupported: true,
    isEmailConfirmationRequired: true,
    isPaymentRequired: true,
};
const DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION = {
    is3pAggregator: true,
    isDeliverySupported: false,
    isEmailConfirmationRequired: false,
    isPaymentRequired: false,
};
exports.PLATFORM_CONFIGURATION = {
    [types_1.Platform.waitr]: { ...DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION },
    [types_1.Platform.grubhub]: { ...DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION },
    [types_1.Platform.biteninja]: { ...DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION },
    [types_1.Platform.doordash]: { ...DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION },
    [types_1.Platform.skip]: { ...DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION },
    [types_1.Platform.uber]: { ...DEFAULT_PLATFORM_AGGREGATOR_CONFIGURATION },
};
/**
 * Takes an order cart and returns fulfillment configuration for the correct platform
 * @param {Platform}
 * @returns a configuration object
 */
function getConfigurationByPlatform(platform) {
    const config = platform && exports.PLATFORM_CONFIGURATION[platform];
    if (!config) {
        return { ...exports.DEFAULT_PLATFORM_CONFIGURATION, isDefault: true };
    }
    return { ...config, isDefault: false };
}
/**
 * Returns if a given platform is a 3P Aggregator
 *
 * @param platform
 * @returns boolean
 */
function isPlatform3pAggregator(platform) {
    const config = getConfigurationByPlatform(platform);
    return config.is3pAggregator;
}
/**
 * Returns a tuple of result, default stating if the payment is required
 * for the given platform
 */
function isPaymentRequired(platform) {
    const { isPaymentRequired, isDefault } = getConfigurationByPlatform(platform);
    return { isDefault, result: isPaymentRequired };
}
/**
 * Returns a tuple of result, default stating if delivery is required
 * for the given platform
 */
function isDeliverySupported(platform) {
    const { isDeliverySupported, isDefault } = getConfigurationByPlatform(platform);
    return { isDefault, result: isDeliverySupported };
}
/**
 * Returns a tuple of result, default stating if the email confirmation
 * is required for the given platform
 */
function isEmailConfirmationRequired(platform) {
    const { isEmailConfirmationRequired, isDefault } = getConfigurationByPlatform(platform);
    return { isDefault, result: isEmailConfirmationRequired };
}
//# sourceMappingURL=fulfillment.js.map